import React from "react";
import PropTypes from "prop-types";

const TrashIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#94A3B8";

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M10.667 11.3333V15.3333"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 11.3333V15.3333"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6663 8V17.3333C16.6663 18.0692 16.0689 18.6667 15.333 18.6667H8.66634C7.93045 18.6667 7.33301 18.0692 7.33301 17.3333V8"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8H18"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 7.99992V6.66659C9.33301 5.9307 9.93045 5.33325 10.6663 5.33325H13.333C14.0689 5.33325 14.6663 5.9307 14.6663 6.66659V7.99992"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

TrashIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

TrashIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default TrashIcon;
